import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { differenceInDays, now, userDate } from 'owa-datetime';

/**
 * This method returns the number of days that have elapsed since the user signed up in Outlook.
 * It uses MailboxCreateDate to calculate the value.
 */
export const getDaysSinceUserSignup = (): number | undefined => {
    try {
        const mailBoxCreateDate = userDate(getUserConfiguration().MailboxCreateDate);

        const diffInDays = differenceInDays(now(), mailBoxCreateDate);
        return diffInDays;
    } catch {
        return undefined;
    }
};
